import React, { Component } from "react"
import { connect } from "react-redux"
import { Form } from "formik-antd"
import { connectModal } from "redux-modal"
import ModalForm from "src/shared/ModalForm"
import withModules from "src/utils/hoc/withModules"
import { AgencyPersist } from "src/ducks/Persist"
import Validate from "./Validate"
import { AgencyName } from "src/shared/AgencyFields"

const AgencyCreate = AgencyPersist("CreateAgencyModal")

const modules = [AgencyCreate.module()]

class CreateAgencyModal extends Component {
  render() {
    const { show, create, handleHide, onCreate } = this.props

    return (
      <ModalForm
        show={show}
        onSave={create}
        afterSave={onCreate}
        validate={Validate}
        handleHide={handleHide}
        title="Create new agency"
      >
        <Form data-cy="agency-create-modal-form">
          <AgencyName />
        </Form>
      </ModalForm>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {
  create: AgencyCreate.create
}

export default withModules(
  connectModal({
    name: "CreateAgencyModal",
    destroyOnHide: false
  })(connect(mapStateToProps, mapDispatchToProps)(CreateAgencyModal))
)(modules)
